import { HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { Kind, OperationTypeNode } from 'graphql';
import { GRAPHQL_URL, GRAPHQL_WS_URL } from 'config';

export const httpLink = new HttpLink({
  uri: GRAPHQL_URL,
  credentials: 'include',
  includeExtensions: true,
});

export const wsLink = new GraphQLWsLink(
  createClient({
    url: GRAPHQL_WS_URL,
  })
);

export const transportLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === Kind.OPERATION_DEFINITION &&
      definition.operation === OperationTypeNode.SUBSCRIPTION
    );
  },
  wsLink,
  httpLink
);
